if (!customElements.get('point-exchange-modal')) {
  class PointExchangeModal extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-point-exchange-open]');
      this.dialog = this.querySelector('[data-point-exchange-dialog]');
      this.closeButton = this.querySelector('[data-point-exchange-close]');

      if (!this.trigger || !this.dialog) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.trigger.addEventListener('click', () => this.open(), { signal });
      this.closeButton?.addEventListener('click', () => this.close(), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.handleClosed(), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();

      if (this.dialog?.open) {
        this.dialog.close();
      }

      this.unlockPage();
    }

    open() {
      if (this.dialog.open) return;

      this.previouslyFocused = document.activeElement;
      this.trigger.setAttribute('aria-expanded', 'true');

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.documentElement.classList.add('point-exchange-dialog-open');
      this.closeButton?.focus();
    }

    close() {
      if (!this.dialog.open) return;

      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.handleClosed();
      }
    }

    handleClosed() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.unlockPage();

      if (this.previouslyFocused instanceof HTMLElement) {
        this.previouslyFocused.focus();
      }
    }

    unlockPage() {
      const openDialog = document.querySelector('.page-point-exchange__dialog[open]');

      if (!openDialog) {
        document.documentElement.classList.remove('point-exchange-dialog-open');
      }
    }
  }

  customElements.define('point-exchange-modal', PointExchangeModal);
}
